import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ConfigService } from '@orion-platform/core';
import { environment } from '@orion/environment';
import { Observable } from 'rxjs';
import { ApiResponse } from '../models/supply-visibility.model';
import { SVComments } from '../models/sv-comments.model';
import { generateHttpParams, getUrl } from '../utils/general.utils';

@Injectable({
  providedIn: 'root',
})
export class SupplyVisibilityCommentService {
  private readonly http = inject(HttpClient);
  private readonly config = inject(ConfigService);

  private readonly baseUrl = this.config.getSettings('apiBaseUrl') as string;
  private readonly mm = environment.modulesBaseUrl.materialManagement;

  getSVCommentsByVendorPN(
    vendor: string,
    partNumber: string,
  ): Observable<ApiResponse<SVComments[]>> {
    const url = getUrl(this.baseUrl, this.mm.getSVCommentsByVendorPN);

    const params = generateHttpParams({
      $skip: 0,
      $top: 100,
      key: `VC:${vendor};PN:${partNumber.toUpperCase()}`,
      modul: 'SupplyVisibility',
    });

    return this.http.get<ApiResponse<SVComments[]>>(url, { params });
  }

  createSVComment(data: SVComments): Observable<SVComments> {
    const url = getUrl(this.baseUrl, this.mm.createSVComment);
    return this.http.post<SVComments>(url, data);
  }

  updateSVComment(data: SVComments): Observable<SVComments> {
    const url = getUrl(this.baseUrl, this.mm.updateSVComment);
    return this.http.post<SVComments>(url, data);
  }

  deleteSVComment(data: SVComments): Observable<SVComments> {
    const url = getUrl(this.baseUrl, this.mm.deleteSVComment);
    const params = generateHttpParams({ id: data.id as string });
    return this.http.post<SVComments>(url, data, { params });
  }
}
